export default __webpack_public_path__ + "static/20_33-6819bd4dc5a11c0caf3437e397262023.png";